import { useContext } from "react";
import "./style.scss";
import utility from "src/utils/utility";
import UserProfiles from "src/app/dashboard/UserProfiles";
import UserContext from "src/provider/state-manager/userProvider";

const Screen2 = () => {
  const {
    user: { profile },
  } = useContext(UserContext);
  return (
    <div>
     <UserProfiles />
    </div>
  );
};

export default utility.routeData("profile", "profile", <Screen2 />);
